const CLEAN_WORDS_MAP = {
  por: 'Position of Responsibility',
  job_industry: 'Industry',
  degree_category: 'Degree',
  'fp&a': 'FP&A',
  job_role: 'Job Role',
  job_function: 'Job Function',
  projects: 'Projects',
  concentration: 'Concentration',
  schools: 'School/University',
  clubs: 'Club/Society',
  awards: 'Awards',
  competitions: 'Competitions',
  certifications: 'Certifications',
  goals: 'Goal Based Keyword',
  company_name: 'Company/Organization',
  contact_information: 'Contact Information',
  coursework: 'Coursework',
  competitive_exams: 'Competitive Exam',
  volunteer_experience: 'Volunteer Experience',
}

export const SECTION_TO_HIGHLIGHT_ENTITIES_MAP = {
  'Personal Information': [],
  'Profile Picture': [],
  Headline: ['language', 'categories', 'skills', 'seo'],
  Summary: ['language', 'impact', 'categories', 'skills', 'seo', 'presentation'],
  Experience: ['language', 'impact', 'categories', 'skills', 'seo', 'presentation'],
  Education: ['categories', 'seo'],
}

export function wrapHeadline(textArray, divWordPosObj = {}, isGenAiFeedback = false) {
  for (let divId in textArray) {
    return {
      type: 'div',
      div_id: divId,
      class: { highlight_class: 'highlightable div-id-' + divId, others: '' },
      text: splitWordPos(textArray[divId]['text'], divId, divWordPosObj, isGenAiFeedback),
    }
  }
}

function splitWordPos(text, divId, divWordPosObj, isGenAiFeedback = false) {
  if (!divWordPosObj.hasOwnProperty(divId)) {
    return [text]
  }
  return splitTextPos(text, divId, divWordPosObj[divId], isGenAiFeedback)
}

function splitTextPos(text, divId, wordPos, isGenAiFeedback = false) {
  if (_.isEmpty(wordPos)) {
    return [text]
  }
  let offset = 0
  if (isGenAiFeedback) {
    const trimmedStartMatch = text.match(/^[\s*\-•‣⁃◦▪▫<>]*(.*)$/)
    const trimmedText = trimmedStartMatch ? trimmedStartMatch[1] : text
    offset = text.length - trimmedText.length
  }
  wordPos = _.sortBy(wordPos, 'pos')
  wordPos = _.map(wordPos, (value, key) => ({
    pos: value['pos'] + offset,
    pos2: value['pos'] + value['word'].length - 1 + offset,
    suggestions: value.hasOwnProperty('suggestions')
      ? value['suggestions']
      : [],
    module_type: value.hasOwnProperty('module_type')
      ? value['module_type']
      : '',
  }))
  let wp = [
    {
      pos: wordPos[0]['pos'],
      pos2: wordPos[0]['pos2'],
      suggestions: wordPos[0]['suggestions'],
      module_type: wordPos[0]['module_type'],
    },
  ]
  let currInd = 0
  for (var i = 1; i < wordPos.length; i++) {
    if (wordPos[i]['pos'] <= wp[currInd]['pos2']) {
      if (wordPos[i]['pos2'] <= wp[currInd]['pos2']) {
        continue
      }
      wp[currInd]['pos2'] = wordPos[i]['pos2']
      continue
    }
    wp.push({
      pos: wordPos[i]['pos'],
      pos2: wordPos[i]['pos2'],
      suggestions: wordPos[i]['suggestions'],
      module_type: wordPos[i]['module_type'],
    })
    currInd++
  }

  let str = ''
  let output = [text.substr(0, wp[0]['pos'])]
  output.push({
    type: 'span',
    key: '0-' + divId,
    div_id: divId,
    class: {
      highlight_class: 'div-id-' + divId + ' word-pos highlightable',
      others: '',
    },
    text: text.substr(wp[0]['pos'], wp[0]['pos2'] - wp[0]['pos'] + 1),
    suggestions: wp[0]['suggestions'],
    module_type: wp[0]['module_type'],
  })
  for (var i = 1; i < wp.length; i++) {
    str = text.substr(
      wp[i - 1]['pos2'] + 1,
      wp[i]['pos'] - wp[i - 1]['pos2'] - 1
    )
    output.push(str)
    str = text.substr(wp[i]['pos'], wp[i]['pos2'] - wp[i]['pos'] + 1)
    output.push({
      type: 'span',
      key: i + '-' + divId,
      div_id: divId,
      class: {
        highlight_class: 'div-id-' + divId + ' word-pos highlightable',
        others: '',
      },
      text: str,
      suggestions: wp[i]['suggestions'],
      module_type: wp[i]['module_type'],
    })
  }
  str = text.substr(wp[currInd]['pos2'] + 1)
  output.push(str)
  return output
}

export function wrapText(feedback, key, divWordPosObj = {}, isGenAiFeedback = false) {
  let output = {}
  if (
    _.isUndefined(feedback[key]) ||
    _.isUndefined(feedback[key]['text_array']) ||
    _.isEmpty(feedback[key]['text_array'])
  ) {
    return {}
  }
  let data = feedback[key]['text_array']
  if (key === 'summary_feedback') {
    output = {
      title: [],
      sub_title: [],
      time_duration: [],
      text: [],
    }
    var k = -1
    for (var i in data) {
      if (data[i]['is_title'] === true) {
        output['title'].push({
          type: 'title_span',
          key: i,
          div_id: i,
          class: {
            highlight_class: 'highlightable div-id-' + i,
            others: 'p-heading-1',
          },
          text: splitWordPos(data[i]['text'], i, divWordPosObj, isGenAiFeedback),
        })
      } else if (data[i]['is_sub_title'] === true) {
        output['sub_title'].push({
          type: 'div',
          key: i,
          div_id: i,
          class: {
            highlight_class: 'highlightable div-id-' + i,
            others: 'p-heading-2',
          },
          text: splitWordPos(data[i]['text'], i, divWordPosObj, isGenAiFeedback),
        })
      } else if (data[i]['is_time_duration'] === true) {
        output['time_duration'].push({
          type: 'div',
          key: i,
          div_id: i,
          class: {
            highlight_class: 'highlightable div-id-' + i,
            others: 'p-date',
          },
          text: splitWordPos(data[i]['text'], i, divWordPosObj, isGenAiFeedback),
        })
      } else {
        var newLine = false
        if (
          (k != -1 &&
            data[k].hasOwnProperty('new_line_id') &&
            data[i].hasOwnProperty('new_line_id') &&
            data[k]['new_line_id'] != data[i]['new_line_id']) ||
          (k == -1 && data[i].hasOwnProperty('new_line_id'))
        ) {
          newLine = true
        }
        var newParagraph = false
        if (
          k != -1 &&
          data[k].hasOwnProperty('paragraph_id') &&
          data[i].hasOwnProperty('paragraph_id') &&
          data[k]['paragraph_id'] != data[i]['paragraph_id']
        ) {
          newParagraph = true
        }
        var endPeriod = data[i]['text'].endsWith('.')
        output['text'].push({
          type: 'span',
          key: i,
          div_id: i,
          class: { highlight_class: 'highlightable div-id-' + i, others: '' },
          bullet: renderBullet(data[i], newLine),
          text: splitWordPos(data[i]['text'], i, divWordPosObj, isGenAiFeedback),
          new_line: newLine,
          new_paragraph: newParagraph,
          end_period: endPeriod,
        })
        k = i
      }
    }
  } else {
    for (let j in data) {
      let obj = data[j]
      output[j] = {
        title: [],
        sub_title: [],
        time_duration: [],
        text: [],
      }
      var k = -1
      for (var i in obj) {
        if (obj[i]['is_title'] === true) {
          output[j]['title'].push({
            type: 'title_span',
            key: i,
            div_id: i,
            class: {
              highlight_class: 'highlightable div-id-' + i,
              others: 'p-heading-1',
            },
            text: splitWordPos(obj[i]['text'], i, divWordPosObj, isGenAiFeedback),
          })
        } else if (obj[i]['is_sub_title'] === true) {
          output[j]['sub_title'].push({
            type: 'div',
            key: i,
            div_id: i,
            class: {
              highlight_class: 'highlightable div-id-' + i,
              others: 'p-heading-2',
            },
            text: splitWordPos(obj[i]['text'], i, divWordPosObj, isGenAiFeedback),
          })
        } else if (obj[i]['is_time_duration'] === true) {
          output[j]['time_duration'].push({
            type: 'div',
            key: i,
            div_id: i,
            class: {
              highlight_class: 'highlightable div-id-' + i,
              others: 'p-date',
            },
            text: splitWordPos(obj[i]['text'], i, divWordPosObj, isGenAiFeedback),
          })
        } else {
          if (key === 'education_feedback' && obj[i]['text'] === 'Grade:') {
            continue
          }
          var newLine = false
          if (
            k != -1 &&
            obj[i].hasOwnProperty('new_line_id') &&
            obj[k].hasOwnProperty('new_line_id') &&
            obj[i]['new_line_id'] != obj[k]['new_line_id']
          ) {
            newLine = true
          }
          var newParagraph = false
          if (
            k != -1 &&
            obj[i].hasOwnProperty('paragraph_id') &&
            obj[k].hasOwnProperty('paragraph_id') &&
            obj[i]['paragraph_id'] != obj[k]['paragraph_id']
          ) {
            newParagraph = true
          }
          if (
            obj[i - 1].hasOwnProperty('new_line_id') === false &&
            obj[i].hasOwnProperty('new_line_id')
          ) {
            newLine = true
          }
          var endPeriod = obj[i]['text'].endsWith('.')
          output[j]['text'].push({
            type: 'span',
            key: i,
            div_id: i,
            class: {
              highlight_class: 'highlightable div-id-' + i,
              others: '',
            },
            bullet: renderBullet(obj[i], newLine),
            text: splitWordPos(obj[i]['text'], i, divWordPosObj, isGenAiFeedback),
            new_line: newLine,
            new_paragraph: newParagraph,
            end_period: endPeriod,
          })
          k = i
        }
      }
    }
  }

  return output
}

function renderBullet(textObj, newLine = true) {
  if (textObj['has_real_bullet_symbol'] == false || newLine == false) {
    return null
  }
  if (textObj.hasOwnProperty('bullet_ascii_value')) {
    if (!_.isEmpty(textObj['original_bullet_full_symbol'])) {
      return textObj['original_bullet_full_symbol']
    }
    return String.fromCharCode(textObj['bullet_ascii_value']).trim() + ' '
  }
  if (textObj.hasOwnProperty('bullet_numeric_value')) {
    return textObj['bullet_numeric_value'].trim() + ' '
  }
}

export function convertDomToString(array) {
  let str = ''
  let divIds = []

  for (let i in array) {
    if (
      i !== '0' &&
      array[i].hasOwnProperty('new_line') &&
      array[i]['new_line'] == true
    ) {
      str += '\n'
    } else if (
      i !== '0' &&
      array[i].hasOwnProperty('new_paragraph') &&
      array[i]['new_paragraph'] == true
    ) {
      str += '\n'
    }

    if (array[i].hasOwnProperty('bullet') && !_.isNull(array[i]['bullet'])) {
      str += array[i]['bullet']
    }
    str += array[i]['text'][0]

    if (
      array[i].hasOwnProperty('end_period') &&
      array[i]['end_period'] == true
    ) {
      str += ' '
    }
    divIds.push({ div_id: array[i]['div_id'], text: array[i]['text'][0] })
  }
  return { text: str.trim(), div_ids: divIds }
}

export function cleanWord(
  word,
  isUKEnable = false,
  displaySet = false,
  fullClean = true
) {
  if (_.isUndefined(word)) {
    return ''
  }
  if (CLEAN_WORDS_MAP.hasOwnProperty(word)) {
    return word === 'company_name' && isUKEnable
      ? 'Company/Organisation'
      : CLEAN_WORDS_MAP[word]
  }
  if (displaySet) {
    return word
  }
  let frags = word.split(/[ _]+/)
  for (let i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  let newWord = frags.join(' ')
  if (!fullClean) {
    newWord = newWord.replace(
      / of | and | for | in |-in-| to | the /gi,
      function myFunction(x) {
        return x.toLowerCase()
      }
    )
  }
  return newWord
}

export function lowerScore(score) {
  return Math.abs(score - 0.01)
}

export function getSectionScore(sectionScoreClass, hasSubSection = false) {
  const score = []
  if (
    _.isNull(sectionScoreClass) ||
    _.isUndefined(sectionScoreClass) ||
    !sectionScoreClass.hasOwnProperty('overall_section_score_class')
  ) {
    return score
  }

  const scoreClass = hasSubSection
    ? sectionScoreClass['overall_section_score_class']['sub_section']
    : [].concat(sectionScoreClass['overall_section_score_class'])
  scoreClass.map((score_data) => {
    score.push({
      color: score_data['color_feedback'],
      score: lowerScore(score_data['overall_section_score']),
    })
  })

  return score
}
